import { Component } from 'react';
import { connect } from 'react-redux';

import cancelablePromise from 'Lib/utilities/cancelablePromise';

import * as app from '~/services/app';

export const withApi = (WrappedComponent, apiCalls, withRedux = true, displayName = 'WithApi') => {
    const apiMap = {};

    Object.keys(apiCalls).forEach(name => {
        apiMap[name] = (...args) => {
            return cancelablePromise(apiCalls[name](...args));
        };
    });

    class Api extends Component {
        pendingPromises = [];

        componentWillUnmount = () => {
            this.pendingPromises.map(p => p.cancel());
        };

        appendPendingPromise = promise => {
            this.pendingPromises = [...this.pendingPromises, promise];
        };

        removePendingPromise = promise => {
            this.pendingPromises = this.pendingPromises.filter(p => p !== promise);
        };

        render() {
            const apiMap = {};

            Object.keys(apiCalls).forEach(name => {
                apiMap[name] = (...args) => {
                    const promise = apiCalls[name](...args);

                    if (withRedux) {
                        app.callApi(promise);
                    }

                    const wrappedPromise = cancelablePromise(promise).finally(() => {
                        this.removePendingPromise(wrappedPromise);
                    });

                    this.appendPendingPromise(wrappedPromise);

                    return wrappedPromise;
                };
            });

            return <WrappedComponent {...this.props} api={apiMap} />;
        }
    }

    Api.displayName = `${displayName}(${WrappedComponent.displayName})`;
    return connect(null, null)(Api);
};

export const withApiNoRedux = (WrappedComponent, apiCalls) => {
    return withApi(WrappedComponent, apiCalls, false, 'WithApiNoRedux');
};

export default withApi;
